import { render } from "./SidebarConfigure.vue?vue&type=template&id=d4b75cb4&scoped=true"
import script from "./SidebarConfigure.vue?vue&type=script&lang=js"
export * from "./SidebarConfigure.vue?vue&type=script&lang=js"

import "./SidebarConfigure.vue?vue&type=style&index=0&id=d4b75cb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4b75cb4"]])

export default __exports__